// extracted by mini-css-extract-plugin
var _1 = "OrganizationOnboardingStepInvite-module__animateUploadProgressBarWidth--eL2dY";
var _2 = "OrganizationOnboardingStepInvite-module__animatedBackground--NRKAb";
var _3 = "OrganizationOnboardingStepInvite-module__invitesLegend--yvbm7";
var _4 = "OrganizationOnboardingStepInvite-module__invitesLegendText--Jc0Ta";
var _5 = "OrganizationOnboardingStepInvite-module__linkIcon--mjtMK";
var _6 = "OrganizationOnboardingStepInvite-module__provisionLink--HwqBL";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "invitesLegend", _4 as "invitesLegendText", _5 as "linkIcon", _6 as "provisionLink" }
